import { render } from "./HostFinancialSetupAlert.vue?vue&type=template&id=78f5618e&scoped=true"
import script from "./HostFinancialSetupAlert.vue?vue&type=script&lang=js"
export * from "./HostFinancialSetupAlert.vue?vue&type=script&lang=js"

import "./HostFinancialSetupAlert.vue?vue&type=style&index=0&id=78f5618e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78f5618e"]])

export default __exports__